import { SVGProps } from 'react'
const SoftPauerLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={80}
        height={80}
        fill="none"
        {...props}
    >
        <path
            fill="#F196C6"
            fillRule="evenodd"
            d="M56.935 45.559c0 7.322-5.934 13.252-13.252 13.252h-6.69a2.92 2.92 0 0 1-2.736-3.936 2.917 2.917 0 0 1 2.736-1.9h6.69a7.415 7.415 0 0 0 7.413-7.416 7.412 7.412 0 0 0-7.413-7.413h-7.158c-1.212 0-2.38-.165-3.495-.472-5.62-1.53-9.757-6.671-9.757-12.781 0-7.322 5.934-13.256 13.252-13.256h6.69a2.917 2.917 0 0 1 2.736 3.936 2.918 2.918 0 0 1-2.736 1.9h-6.69a7.415 7.415 0 0 0-7.413 7.416 7.411 7.411 0 0 0 7.413 7.414h7.158c1.212 0 2.38.164 3.495.47 5.624 1.53 9.757 6.673 9.757 12.782v.004Z"
            clipRule="evenodd"
        />
        <path
            fill="#E5006B"
            fillRule="evenodd"
            d="M46.55 45.602a2.917 2.917 0 0 1-2.918 2.918h-8.717a6.053 6.053 0 0 0-5.803 6.047v11.606a2.92 2.92 0 0 1-2.918 2.918 2.92 2.92 0 0 1-2.918-2.918V54.57c0-6.497 5.171-11.777 11.643-11.88H43.639a2.917 2.917 0 0 1 2.918 2.918l-.007-.007Z"
            clipRule="evenodd"
        />
    </svg>
)
export default SoftPauerLogo
